import { PaginationAdapter } from '@red/data-access';
import { createAction, props } from '@ngrx/store';
import { PaymentGeneratorModel } from '@shared/data-access/models';
import { IQuerySearch } from '@shared/data-access/interfaces';
// items
export const loadItems = createAction('[PaymentGenerator] Load items', props<{ filters: IQuerySearch }>());
export const loadItemsSuccess = createAction('[PaymentGenerator] Load items success', props<{ data: PaginationAdapter<PaymentGeneratorModel> }>());

// item
export const loadItem = createAction('[PaymentGenerator] Load item', props<{ id: number }>());
export const loadItemSuccess = createAction('[PaymentGenerator] Load item success', props<{ item: PaymentGeneratorModel }>());
